import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Check, Loader2, Anchor } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShareSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    let attempt = 0;

    async function poll() {
      if (cancelled) return;
      if (attempt >= 10) {
        setStatus("timeout");
        return;
      }
      attempt += 1;
      try {
        const res = await axios.get(`${API}/group/checkout/status/${sessionId}`);
        if (cancelled) return;
        setData(res.data);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    }
    poll();
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-6" data-testid="share-success-page">
      <div className="w-full max-w-xl bg-white border border-[color:var(--am-line)] p-12 text-center">
        <div className="flex justify-center mb-8">
          {status === "checking" && <Loader2 size={28} className="text-navy animate-spin" />}
          {status === "paid" && (
            <div className="w-14 h-14 bg-navy text-white flex items-center justify-center">
              <Check size={24} strokeWidth={1.5} />
            </div>
          )}
        </div>

        {status === "checking" && (
          <>
            <div className="overline mb-3">Confirming</div>
            <h1 className="font-serif-display text-4xl text-navy mb-4">Locking your share…</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="overline mb-3">Share Paid</div>
            <h1 className="font-serif-display text-4xl text-navy mb-4">You're in.</h1>
            <p className="text-[color:var(--am-muted)] max-w-md mx-auto">
              Your share has been recorded. The charter locks once everyone in the group has paid — we'll send a final confirmation by email.
            </p>
          </>
        )}
        {status === "timeout" && (
          <>
            <h1 className="font-serif-display text-4xl text-navy mb-4">Almost there.</h1>
            <p className="text-[color:var(--am-muted)]">Your payment is settling. We'll confirm by email.</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-serif-display text-4xl text-navy mb-4">No session found.</h1>
          </>
        )}

        <div className="flex justify-center gap-3 mt-10">
          <Link to="/" className="btn-secondary" data-testid="share-success-home">
            <Anchor size={14} /> Home
          </Link>
          {data?.booking_id && (
            <Link to={`/share/${data.booking_id}`} className="btn-primary" data-testid="share-success-progress">
              View Group Progress
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
